import type { IRowNode } from '@mint-lib/ag-grid/community';

export function includeSelectedParents(nodes: IRowNode[]) {
  const parents = new Set<IRowNode>();

  for (const node of nodes) {
    let pointer = node.parent;

    while (pointer != null) {
      if (pointer.isSelected()) {
        parents.add(pointer);
      }
      pointer = pointer.parent;
    }
  }

  return Array.from(parents)
    .concat(nodes)
    .map((node) => node.data)
    .filter((id) => id !== undefined);
}
